
export class ObjectCommon {
    //Hàm khởi tạo
    constructor(type, startDate, endDate) {
        this.type = type;
        this.startDate = startDate;
        this.endDate = endDate;
    }

    //Khai báo phương thức
    getType() {
        return this.type
    }
    getStartDate() {
        return this.startDate
    }
    getEnnDate() {
        return this.endDate
    }

}
